import { render, staticRenderFns } from "./RevenueTypeEdit.vue?vue&type=template&id=377f4e8b&scoped=true&"
import script from "./RevenueTypeEdit.vue?vue&type=script&lang=js&"
export * from "./RevenueTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f4e8b",
  null
  
)

export default component.exports